<template>
  <div class="productW">
    <div class="productSection wow animate__slideInUp">
      <el-image class="bookFigure" :src="Product.PicUrl" fit="cover"><div slot="placeholder" class="image-slot"></div></el-image>
      <!-- :src="require('@/assets/images/product2.jpg')" -->

      <div class="productTxt">
        <h3>{{lang=="en"?'PRODUCTS':'产品介绍'}}</h3>
        <p>{{ Product.Summary }}</p>
        <div><router-link to="/productIntroduce/top"><span class="bigMore">{{lang=="en"?'Learn More':'了解更多'}}</span></router-link></div>
      </div>
    </div>
    <div class="productSection wow animate__slideInUp">
      <div class="productTxt">
        <h3>{{lang=="en"?'QUALITY ASSURANCE':'研发核心'}}</h3>
        <p>{{ RdCore.Summary }}</p>
        <div><router-link :to="lang=='zh'?'/product':'/productIntroduce/two'"><span class="bigMore">{{lang=="en"?'Learn More':'了解更多'}}</span></router-link></div>
      </div>
      <el-image class="bookFigure twoType" fit="cover" :src="RdCore.PicUrl"><div slot="placeholder" class="image-slot"></div></el-image>
      <!-- src="images/product.png" -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["Product", "RdCore","lang"],
};
</script>

<style lang="scss">
.productW {
  background: #fff;
  margin: 50px 0;
}
.productSection {
  display: grid;
  grid-template-columns: 50% 50%;

  .productTxt {
    padding: 30px;
    h3 {
      font-size: 24px;
      font-weight: 500;
    }
    p {
      padding: 10px 0 50px;
    }
    .bigMore {
      color: #000;
      border: 1px solid #bfbfbf;
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>